import React, { useEffect, useMemo, useState } from "react";
import * as S from "./FormSteps.style";
import * as P from "../../../../../../../utils/pipes";
import { useTranslation } from "react-i18next";
import ListGroupStages from "../listGroupStages";
import ListStages from "../listStages";
import EndStatusChange from "../endStatusChange";
import FlorenzBreadcrumb from "../../../../../../florenzComponents/florenzBreadCrumb";
import { QUERY_GET_ALL_PROCESS_GROUP_STAGES } from "../../../../../../../graphql/queries/ProcessStage";
import { useQuery } from "@apollo/client";

function FormSteps({
  patient,
  processSelected,
  frequency,
  newCurrenStatusData,
  processStagesData,
  statusSelectionView,
  setStatusSelectionView,
  currentStatus,
  newCurrentStatus,
  setNewCurrentStatus,
  counterStage,
  setCounterStage,
  newCounterStage,
  setNewCounterStage,
  statusDescription,
  setStatusDescription,
  statusDate,
  setStatusDate,
  changeStatusSteps,
  processGroupStages
}) {

  const {t, i18n: { language }} = useTranslation("global");
  const [groupStageId, setGroupStageId] = useState();
  const [currentStep, setCurrentStep] = useState();

  useEffect(() => {
    console.log("I",statusSelectionView);
    console.log("couldnt", changeStatusSteps.find((step) => step.id === statusSelectionView));
    
    
    setCurrentStep(changeStatusSteps.find((step) => step.id === statusSelectionView));
  }, [statusSelectionView, processGroupStages, changeStatusSteps]);

  useEffect(() => {
    const searchGroupStageId = processStagesData?.process[0]?.processStages?.find((stage) => stage.id === currentStatus)?.groupStageValue;
    console.log("love", processStagesData?.process[0]?.processStages?.find((stage) => stage.id === currentStatus)?.groupStageValue);
    console.log("you",  currentStatus);
    
    setGroupStageId(searchGroupStageId === null ? 0 : searchGroupStageId)
  }, [processStagesData, currentStatus])

  useEffect(() => {

  }, [changeStatusSteps])

  return (
    <S.FormSteps>
      <div className="steps">
        <div className="steps__title">
          {t("changeOfStatus.steps")}
        </div>
        <FlorenzBreadcrumb
          steps={changeStatusSteps}
          setStep={setStatusSelectionView}
          stepSelected={statusSelectionView}
        />
      </div>
      <div className="step-container">
        {
          currentStep &&
          <currentStep.cmp
            frequency={frequency}
            processStagesData={processStagesData}
            currentStatus={currentStatus}
            newCurrenStatusData={newCurrenStatusData}
            counterStage={counterStage}
            setCounterStage={setCounterStage}
            newCounterStage={newCounterStage}
            setNewCounterStage={setNewCounterStage}

            newCurrentStatus={newCurrentStatus}
            setNewCurrentStatus={setNewCurrentStatus}
            patient={patient}
            processSelected={processSelected}
            statusSelectionView={statusSelectionView}

            statusDescription={statusDescription}
            setStatusDescription={setStatusDescription}
            statusDate={statusDate}
            setStatusDate={setStatusDate}
            
            processGroupStages={processGroupStages}
            groupStageId={groupStageId}
            setGroupStageId={setGroupStageId}
          />
        }
      </div>
    </S.FormSteps>
  );
}

export default FormSteps;
